module.exports = __webpack_public_path__ + "static/media/save_changes_icon.cadd752c.svg";